import * as React from "react";

const R = 30;

export type ProgressBarNumbers = {
  numPassed: number;
  numChecked: number;
  numFailed: number;
  numCaution: number;
};

const CircularProgressBar = ({ numbers }: { numbers: ProgressBarNumbers }) => {
  const { numPassed, numChecked } = numbers;
  const angle = (numPassed / (numChecked || 1)) * Math.PI * 2;

  // Splitting circle into two halves because you can't draw a full circle in SVG
  // using a single Arc command.
  const angle1 = angle > Math.PI ? Math.PI : angle;
  const angle2 = angle > Math.PI ? angle : null;

  const centerX = R * 2;
  const centerY = R * 2;

  const arcX0 = R * 2;
  const arcY0 = R;

  const arcX1 = centerX + Math.sin(angle1) * R;
  const arcY1 = centerY - Math.cos(angle1) * R;

  const pathD = [`M ${arcX0} ${arcY0}`, `A ${R} ${R} 0 0 1 ${arcX1} ${arcY1}`];

  if (angle2 !== null) {
    const arcX2 = centerX + Math.sin(angle2) * R;
    const arcY2 = centerY - Math.cos(angle2) * R;
    pathD.push(`A ${R} ${R} 0 0 1 ${arcX2} ${arcY2}`);
  }

  return (
    <div className="circular-progress-bar">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={R * 4}
        height={R * 4}
        viewBox={`0 0 ${R * 4} ${R * 4}`}
      >
        <text x={R * 2} y={R * 2} dy={"2px"} textAnchor="middle" dominantBaseline="middle">
          {numPassed}/{numChecked}
        </text>
        <circle cx={R * 2} cy={R * 2} r={R - 10} strokeWidth="2px" fill="none" />
        <circle cx={R * 2} cy={R * 2} r={R + 10} strokeWidth="2px" fill="none" />
        <path d={pathD.join(" ")} strokeWidth={"20px"} />
        <line x1={R * 2} y1={R - 9} x2={R * 2} y2={R + 9} stroke="white" strokeWidth="2px" />
      </svg>
      <div>{progressText(numbers)}</div>
    </div>
  );
};

function progressText(numbers: ProgressBarNumbers): string {
  const { numPassed, numChecked, numFailed, numCaution } = numbers;
  const bits = [];
  bits.push(`${numPassed} out of ${numChecked} passed`);
  if (numFailed) {
    bits.push(`${numFailed} failed`);
  }
  if (numCaution) {
    bits.push(`${numCaution} requires inspection`);
  }

  return bits.join(", ");
}

export default CircularProgressBar;
